import React from 'react';
import './style.css';
import NavbarCustom from '../../Components/NavbarCustom';
import { useNavigate } from 'react-router-dom';

export const PaymentFailed = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/buy-packages'); // go back to the packages page
  };

  return (
    <>
      <NavbarCustom />
      <div className="payment-failed-container">
        <div className="payment-failed-card">
          <div className="payment-failed-icon">❌</div>
          <h1 className="payment-failed-title black-text-clip">Payment Failed</h1>
          <p className="payment-failed-message black-text-clip">
            Something went wrong while processing your payment. Please try again.
          </p>
          <button className="payment-failed-button" onClick={handleRetry}>
            Try Again
          </button>
        </div>
      </div>
    </>
  );
};
